import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@atoms/Typography';
import Grid from '@mui/material/Grid';
import { HeaderContainer, TitleContainer } from './style';

const PageHeader = ({ title, icon, children }) => (
  <Grid container>
    <Grid item xs={12} md={4}>
      <TitleContainer>
        {icon}
        <Typography variant="h4">
          {title}
        </Typography>
      </TitleContainer>
    </Grid>
    <Grid item xs={12} md={8}>
      {children}
    </Grid>
  </Grid>
);

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node,
  children: PropTypes.node,
};

PageHeader.defaultProps = {
  children: undefined,
  icon: undefined
};

export default PageHeader;
